import { Grid, Typography } from '@mui/material'
import { mediaSelectors } from '@/features/media/slice'
import { useAppSelector } from '@/redux/hooks'
import { Categories } from '../inputs/Categories'
import { MediaNumber } from '../inputs/MediaNumber'
import { ProductTypes } from '../inputs/ProductType'
import { SubIndustries } from '../inputs/SubIndustries'
export const DocumentInformation = () => {
  const platform = useAppSelector(mediaSelectors.selectPlatform)

  return (
    <Grid container spacing={1}>
      <Grid size={12}>
        <Typography variant="h2">Document Information</Typography>
      </Grid>
      <Grid size={{ sm: 12, lg: 3 }}>
        <MediaNumber />
      </Grid>
      <Grid size={{ sm: 12, lg: 'grow' }}>
        <Categories />
      </Grid>
      <Grid size={{ sm: 12, lg: 'grow' }}>
        <ProductTypes />
      </Grid>
      {platform === 'Cat' ? (
        <Grid size={{ sm: 12, lg: 'grow' }}>
          <SubIndustries />
        </Grid>
      ) : null}
    </Grid>
  )
}
